import React from "react";

import OverlayData from "components/nHotdogChart/OverlayData";

import { BarChart, Bar, CartesianGrid, Tooltip, XAxis, YAxis, ResponsiveContainer, Label, Cell } from "recharts";

import styles from "./style.module.css";

const CustomToolTip = (props) => {
  const { active, payload, label, outcome } = props;
  if (!active || !payload || !payload[0] || !payload[0].payload) {
    return null;
  }

  const value = Number(payload[0].payload.baseline) + Number(payload[0].payload.percentage);

  return (
    <div className={styles.popupHolder}>
      <OverlayData
        bar={payload[0].payload.bar}
        valueHover={payload[0].payload.valueHover}
        baseline={payload[0].payload.baseline}
        isContinuous={payload[0].payload.isContinuous}
        outcome={outcome}
        isQuickRun={false}
        showLevelImportance={true}
      />
    </div>
  );
};

class SelectedFeatureChart extends React.Component {
  render() {
    const { bars, handleSelect, fieldSelect, selected, isContinuous, labelData, model, outcome } = this.props;

    if (bars === undefined || bars.length === 0) {
      return <div />;
    }

    const isOrdered =
      model &&
      model.features &&
      model.features.percentages &&
      model.features.percentages[fieldSelect] &&
      model.features.percentages[fieldSelect].ordered === true &&
      model.features.percentages[fieldSelect].index
        ? true
        : false;

    const retBars = bars
      .sort((a, b) => {
        if (isOrdered !== true) {
          const valA = a.value && a.value.replace("more than ", "");
          const valB = b.value && b.value.replace("more than ", "");
          if (typeof valA === "string" || typeof valB === "string") {
            let numA = valA.split(" to ")[0] || "NaN";
            let numB = valB.split(" to ")[0] || "NaN";
            if (isNaN(numA) || isNaN(numB)) {
              return valA < valB ? -1 : 1;
            } else {
              return parseFloat(numA) - parseFloat(numB);
            }
          } else {
            return valA < valB ? -1 : 1;
          }
        }
      })
      .map((b) => {
        let newVal = b.value;
        if (newVal && newVal.length > 20) {
          const splitVal = newVal.split(" to ");
          if (splitVal.length === 2 && !isNaN(splitVal[0]) && !isNaN(splitVal[1])) {
            splitVal.forEach((elem, index) => {
              if (elem.length > 10) {
                splitVal[index] = elem.slice(0, 8) + "...";
              }
            });
            newVal = splitVal.join(" to ");
          } else {
            newVal = newVal.slice(0, 20) + "...";
          }
        }
        let percentage = b.percentage;
        return {
          ...b,
          scaledPercentage: b.percentage * 100,
          bar: {
            label: fieldSelect,
            leftModel: labelData.label,
            left: labelData.score * 100
          },
          valueHover: {
            label: b.value,
            value: b.percentage
          },
          baseline: labelData.baseline / 10000,
          value: newVal,
          value_real: b.value,
          percentage: b.percentage,
          isContinuous: Boolean(isContinuous)
        };
      });

    let maxChars = 0;

    retBars &&
      retBars.forEach((p) => {
        if (p.value && p.value.toString().length > maxChars) {
          maxChars = p.value.toString().length;
        }
        p.label = labelData.label;
        p.score = labelData.score * 100;
        p.baseline = labelData.baseline;
      });

    return (
      <div className={styles.selectedFeatureChart} id="selectedFeatureChart">
        <ResponsiveContainer>
          <BarChart
            margin={{
              top: 10,
              right: 20,
              bottom: 20
            }}
            layout="vertical"
            data={retBars}
            onClick={() => {}}
          >
            <YAxis type="category" dataKey={"value"} width={7 * maxChars + 20}></YAxis>
            {isContinuous ? (
              <XAxis type="number" dataKey={"percentage"} name={"Prediction Change"}>
                <Label value={"Prediction Change"} offset={0} position="bottom" />
              </XAxis>
            ) : (
              <XAxis type="number" dataKey={"scaledPercentage"} name={"Percentage"} unit={"%"}>
                <Label value={"Percentage"} offset={0} position="bottom" />
              </XAxis>
            )}
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip content={<CustomToolTip outcome={outcome} />} />
            <Bar
              dataKey={isContinuous ? "percentage" : "scaledPercentage"}
              onClick={(e) => {
                const nValue = e.payload.value_real ? e.payload.value_real : e.payload.value;
                return handleSelect(selected === nValue ? undefined : nValue);
              }}
            >
              {retBars.map((p, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={
                    p.percentage > 0
                      ? //? "var(--aible-color)"
                        `rgb(125, 105, 215${selected !== undefined && p.value_real !== selected ? ", 0.5" : ""})`
                      : `rgb(213, 107, 39${selected !== undefined && p.value_real !== selected ? ", 0.5" : ""})`
                    //: "rgba(14, 168, 189, 0.15)"
                  }
                  stroke={p.percentage > 0 ? "var(--aible-color)" : "#F47C20"}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default SelectedFeatureChart;
